import React from "react";
import { Outlet, Link } from "react-router-dom";
import { SocialMedia } from "../SocialMedia";

interface Props {
  User: any;
}

const SecureMenu = (props: Props) => {
  return (
    <div>
      <div className="section">
        <nav className="navbar navbar-expand-lg fixed-top nav-down">
          <div className="container">
            <div className="navbar-translate">
              <div className="navbar-brand">
                <h3>Hanna Kaciniel</h3>
              </div>

              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navigation"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-bar bar1"></span>
                <span className="navbar-toggler-bar bar2"></span>
                <span className="navbar-toggler-bar bar3"></span>
              </button>
            </div>
            <div
              className="collapse navbar-collapse"
              data-nav-image="#"
              data-color="orange"
            >
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link className="nav-link" to={`about`}>
                    About
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`paintings/:Params`}>
                    Paintings
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`availableprints/:Params`}>
                    Prints
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={`contact`}>
                    Contact
                  </Link>
                </li>

                <li className="dropdown nav-item">
                  <a
                    className="dropdown-toggle nav-link"
                    href="#"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Admin
                  </a>
                  <div className="dropdown-menu dropdown-menu-right dropdown-danger">
                    <Link className="dropdown-item" to={`addpainting`}>
                      Add Painting
                    </Link>
                    <Link className="dropdown-item" to={`addsize`}>
                      Add Size Value
                    </Link>
                    <Link className="dropdown-item" to={`sizes`}>
                      Sizes
                    </Link>
                    <Link className="dropdown-item" to={`addshipping`}>
                      Add Shipping Value
                    </Link>
                    <Link className="dropdown-item" to={`shipping`}>
                      Shipping
                    </Link>
                    <Link className="dropdown-item" to={`addprint`}>
                      Add Print
                    </Link>
                    <Link className="dropdown-item" to={`prints`}>
                      Prints
                    </Link>
                    <Link className="dropdown-item" to={`logout`}>
                      Log Out
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <div className="section">
        <div id="detail" className="container">
          <SocialMedia Class="col-md-12 social-media" Type="Header" />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SecureMenu;
